import { Link } from "react-router-dom";
import classNames from "classnames";
export default function MnLink({ to, name, variant = "primary", classes }) {
  const baseStyles =
    "inline-block px-6 py-2 mb-4 rounded-lg transition-colors duration-300 ease-in-out text-base";

  const variantStyles = {
    primary: `
      bg-primary-500 text-white 
      hover:bg-primary-400 
      active:bg-primary-400
    `,
    secondary:
      "bg-white text-primary hover:bg-primary-400 active:bg-primary-400  hover:text-white active:text-white",
    danger: "bg-red-500 text-white hover:bg-red-600",
    success: "bg-green-500 text-white hover:bg-green-600",
    outline:
      "border-2 border-primary-500 text-primary-500 hover:bg-primary-500 hover:text-white",
  };

  return (
    <Link
      to={to}
      className={classNames(
        baseStyles,
        variantStyles[variant] || variantStyles.primary,
        classes
      )}
    >
      {name}
    </Link>
  );
}
